import { ContainerNavEl } from 'components/containerNav/ContainerNav.styled';

const ContainerNav = ({ children }) => {
  return <ContainerNavEl>{children}</ContainerNavEl>;
};

export default ContainerNav;
